import { render, staticRenderFns } from "./agentApplicationDetails.vue?vue&type=template&id=64135f48"
import script from "./agentApplicationDetails.vue?vue&type=script&lang=ts"
export * from "./agentApplicationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports